<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import ContactForm from "../components/ContactForm.svelte";
	import ProductBreadcrumb from "../components/product/ProductBreadcrumb.svelte";
	import ProductContent from "../components/product/ProductContent.svelte";
	import ProductGallery from "../components/product/ProductGallery.svelte";
	import ProductInfo from "../components/product/ProductInfo.svelte";
	import type { ProductProps } from "./ProductProps.js";

	const { product }: ProductProps = $props();
</script>

<Layout>
	<section class="full-width bg-zms-grey grid-container py-10 md:py-[5.5rem]">
		<div class="flex flex-col md:gap-16 gap-6">
			<ProductBreadcrumb {product} />
			<div class="flex flex-col-reverse md:flex-row md:justify-between gap-8 md:gap-[8.1875rem]">
				<ProductInfo {product} />
				<ProductGallery {product} />
			</div>
		</div>
	</section>

	<ProductContent contents={product.contents} />

	<ContactForm productName={product.name} heading="getPrice" />
</Layout>
